import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`auth-icon ${_vm.selected ? '': 'auth-icon-other'}`},[_c(VIcon,{class:`text-${_vm.textVariant}`,attrs:{"x-large":""}},[_vm._v("mdi-"+_vm._s(_vm.icons[_vm.provider]))]),(_vm.showName)?_c('div',[_c('small',{class:`text-${_vm.textVariant}`},[_vm._v(_vm._s(_vm.provider))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }